<template>
  <div>
    <wc-page-title title='Budget Status'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar :loading='isLoading'>
            <v-data-table
              :items='budgetItems'
              :headers='headers'
              dense
              :sort-by="['division_obj.division', 'main_category_obj.description', 'sub_category_obj.description', 'sub_sub_category_obj.description']"
              :items-per-page='-1'
              hide-default-footer
              show-expand
              single-expand
              item-key='id'
              :expanded='expanded'
              @item-expanded='getRelatedExpenses'
            >
              <template v-slot:item.amount='{ item }'>
                {{ item.amount | dec }}
              </template>
              <template v-slot:item.amount_used='{ item }'>
                {{ item.amount_used | dec }}
              </template>
              <template v-slot:expanded-item='{ item }' class='bg-success'>
                <td></td>
                <td :colspan='headers.length' v-if='loadingRelatedExpenses'>
                  <wc-loading line :dump='item'></wc-loading>
                </td>
                <td :colspan='headers.length' v-else>
                  <v-card tile outlined class='my-2'>
                    <v-simple-table dense>
                      <thead>
                        <th class='text-left pl-4'>Date</th>
                        <th class='text-left'>Location</th>
                        <th class='text-right pr-4'>Amount</th>
                      </thead>
                      <tr><td :colspan="headers.length + 1"><v-divider></v-divider></td></tr>
                      <tbody>
                        <tr v-if='relatedExpenses.length === 0'>
                          <td colspan="3">
                            No connected expense lines found
                          </td>
                        </tr>
                        <tr v-else v-for='e in relatedExpenses' :key='e.id' @click='openExpense(e)'>
                          <td class='text-left' v-if='e.expense'>{{ e.expense_obj.expense_date | shortDate }}</td>
                          <td class='text-left' v-else>(no info)</td>
                          <td class='text-left' v-if='e.expense'>{{ e.expense_obj.purchased_at }}</td>
                          <td class='text-left' v-else>(no info)</td>
                          <!-- <td class='text-right' v-if='e.expense'>{{ e.expense_obj.total | dec }}</td> -->
                          <td class='text-right' v-if='e.expense'>{{ e.amount | dec }}</td>
                          <td class='text-right' v-else>(no info)</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </td>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import budgetsAPI from '@/modules/management/api/budgets';
import expensesAPI from '@/api/accounting';
import miscServices from '@/services/misc';

export default {
  name: 'budget-status',
  data: () => ({
    isLoading: true,
    budget: {},
    budgetItems: [],
    expanded: [],
    relatedExpenses: [],
    loadingRelatedExpenses: false,
    headers: [
      { text: 'Division', value: 'division_obj.division' },
      { text: 'Main category', value: 'main_category_obj.description' },
      { text: 'Sub category', value: 'sub_category_obj.description' },
      { text: 'Sub SUB category', value: 'sub_sub_category_obj.description' },
      { text: 'Notes', value: 'notes' },
      { text: 'Budgeted', value: 'amount', align: 'right' },
      { text: 'Used', value: 'amount_used', align: 'right' }
    ]
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.expenses
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.budget = await budgetsAPI.getActiveBudget()
      this.budgetItems = await budgetsAPI.getActiveBudgetLineItems()
      this.isLoading = false
    },
    async getRelatedExpenses(obj) {
      this.loadingRelatedExpenses = true
      if (obj.value === true) {
        this.relatedExpenses = await expensesAPI.getBudgetItemExpenses(obj.item.id)
      }
      this.loadingRelatedExpenses = false
      return this.relatedExpenses
    },
    openExpense (exp) {
      miscServices.openInNewTab({ name: 'ExpenseOverview', params: { id: exp.expense } })
    }
  }
}
</script>
